import {
	createContext,
	useContext,
	type Dispatch,
	type SetStateAction,
} from 'react';

export interface NavDialogsContextValue {
	isEditUserOpen: boolean;
	isFavoritesOpen: boolean;
	isMakePaymentOpen: boolean;
	isReferFriendModalOpen: boolean;
	isSecureNotesOpen: boolean;
	setIsEditUserOpen: Dispatch<SetStateAction<boolean>>;
	setIsFavoritesOpen: Dispatch<SetStateAction<boolean>>;
	setIsMakePaymentOpen: Dispatch<SetStateAction<boolean>>;
	setIsReferFriendModalOpen: Dispatch<SetStateAction<boolean>>;
	setIsSecureNotesOpen: Dispatch<SetStateAction<boolean>>;
}

const navDialogsContext = createContext<NavDialogsContextValue | null>(null);

export const useNavDialogsContext = () => {
	const context = useContext(navDialogsContext);
	if (!context) {
		throw new Error(
			'useNavDialogsContext must be used within a NavDialogsProvider',
		);
	}
	return context;
};

export default navDialogsContext;
